import type { PlanId } from "@/lib/branchTypes"
import { PLAN_LETTER_HALO_PX } from "./planLetterLabels"
import {
  PLAN_PREVIEW_FADE_MS,
  PLAN_PREVIEW_HALO_EXTRA_PX,
  PLAN_PREVIEW_LINE_COLOR,
  type PlanPreviewFan,
} from "./planPreviewFan"

// Two passes so the fan reads over the red dither: first ALL the
// page-colored knock-out halos (a clean gutter cut through the field for
// every line), then ALL the black lines on top — a halo never erases a
// neighbouring line because every halo paints before any line. Fades
// in/out with the choice point via the group's opacity transition.
export const PlanPreviewFanSvg = ({
  fan,
  isShown,
  letterLabeledPlan,
  backgroundColor,
}: {
  fan: PlanPreviewFan
  isShown: boolean
  // The hovered/chosen plan whose letter is visible; null = anonymous
  // fan (the default-emphasized D gets no letter until actually picked).
  letterLabeledPlan: PlanId | null
  backgroundColor: string
}) => (
  <g
    style={{
      opacity: isShown ? 1 : 0,
      transition: `opacity ${PLAN_PREVIEW_FADE_MS}ms ease-in-out`,
    }}
  >
    {fan.paths.map(({ planId, d, strokeWidth }) => (
      <path
        key={`fan-halo-${planId}`}
        d={d}
        stroke={backgroundColor}
        strokeWidth={strokeWidth + PLAN_PREVIEW_HALO_EXTRA_PX * 2}
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    ))}
    {fan.paths.map(({ planId, d, strokeWidth, dash }) => (
      <path
        key={`fan-${planId}`}
        d={d}
        stroke={PLAN_PREVIEW_LINE_COLOR}
        strokeWidth={strokeWidth}
        strokeDasharray={dash}
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    ))}
    {/* Baseline at the anchor y — close enough to the desktop's
        box-bottom anchor for descender-free capitals. */}
    {fan.letters.map(({ planId, x, y }) => (
      <text
        key={`fan-letter-${planId}`}
        x={x}
        y={y}
        textAnchor="end"
        className="font-mono text-xs font-bold"
        fill={PLAN_PREVIEW_LINE_COLOR}
        stroke={backgroundColor}
        strokeWidth={PLAN_LETTER_HALO_PX}
        strokeLinejoin="round"
        paintOrder="stroke"
        style={{ opacity: planId === letterLabeledPlan ? 1 : 0 }}
      >
        {planId}
      </text>
    ))}
  </g>
)
